import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, merge, mergeMap, of, pipe, switchMap, take, tap } from "rxjs";
import * as WearingPartCategoryActions from "./actions";
import { AppNotificationService } from "src/app/shared/services/notification.service";
import { translate } from '@jsverse/transloco';
import { IWearingPartCategory } from "src/app/devices/models/wearing-part-categories";
import { WearingPartCategoryService } from "src/app/devices/services/wearing-part-category.service";

@Injectable()
export class WearingPartCategoriesEffets {

    //////////////////////////////////
    // GET WEARING PART CATEGORIES //
    ////////////////////////////////

    // Get Wearing Part Categories
    getWearingPartCategories$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.getWearingPartCategories), 
            mergeMap(() => {
            return this.wearingPartCategoryService.getWearingPartCategories({pageNumber: 0, pageSize: 25}).pipe(
                map((response) => 
                    WearingPartCategoryActions.getWearingPartCategoriesSuccess({ wearingPartCategories: response.data })
                ), 
                catchError((error) =>
                    of(WearingPartCategoryActions.getWearingPartCategoriesFailure({ error: error.message }))
                )
            );
        }),
        take(1)
        )
    );




    ///////////////////////////////////
    // CREATE WEARING PART CATEGORY //
    /////////////////////////////////

    // Create Wearing Part Category
    createWearingPartCategory$ = createEffect(() =>
      this.actions$.pipe(
          ofType(WearingPartCategoryActions.createWearingPartCategory),
          mergeMap((action) => 
              this.wearingPartCategoryService.createWearingPartCategory(action.wearingPartCategory).pipe(
                  map((wearingPartCategory: IWearingPartCategory) => WearingPartCategoryActions.createWearingPartCategorySuccess({ wearingPartCategory })),
                  catchError((error) => of(WearingPartCategoryActions.createWearingPartCategoryFailure({ error: error.message })))
              )
          )
      )
    );

    // Wearing Part Category created successfully
    createWearingPartCategorySuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.createWearingPartCategorySuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.wearingPartCategories.createSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );

    // Wearing Part Category not created successfully
    createWearingPartCategoryFailure$ = createEffect(() => 
      this.actions$.pipe(
          ofType(WearingPartCategoryActions.createWearingPartCategoryFailure)
      ), { dispatch: false }
    );




    ///////////////////////////////////
    // UPDATE WEARING PART CATEGORY //
    /////////////////////////////////

    // Update Wearing Part Category
    updateWearingPartCategory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.updateWearingPartCategory),
            mergeMap((action) => 
                this.wearingPartCategoryService.updateWearingPartCategory(action.wearingPartCategory).pipe(
                    map((wearingPartCategory: IWearingPartCategory) => WearingPartCategoryActions.updateWearingPartCategorySuccess({ wearingPartCategory })),
                    catchError((error) => of(WearingPartCategoryActions.updateWearingPartCategoryFailure({ error: error.message })))
                )
            )
        )
    );
  
    // Update Wearing Part Category successful
    updateWearingPartCategorySuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.updateWearingPartCategorySuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.wearingPartCategories.updateSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );
  
    // Wearing Part Category not updated successfully
    updateWearingPartCategoryFailure$ = createEffect(() => 
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.updateWearingPartCategoryFailure),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('settings.wearingPartCategories.updateFailed'), style: 'error' });
            })
        ), { dispatch: false }
    );




    ///////////////////////////////////
    // DELETE WEARING PART CATEGORY //
    /////////////////////////////////

    // Delete Wearing Part Category
    deleteWearingPartCategory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(WearingPartCategoryActions.deleteWearingPartCategory), 
            mergeMap((action) => {
                return this.wearingPartCategoryService.deleteWearingPartCategory(action.id).pipe(
                    map(() => WearingPartCategoryActions.deleteWearingPartCategorySuccess({id: action.id})), 
                    catchError((error) => of(WearingPartCategoryActions.deleteWearingPartCategoryFailure({ error: error.message })))
            )}
        ))
    );

    // Wearing Part Category deleted successfully
    deleteWearingPartCategorySuccess$ = createEffect(() => 
      this.actions$.pipe(
          ofType(WearingPartCategoryActions.deleteWearingPartCategorySuccess),
          tap(() => {
              this.appnotificationService.notification$.next({ message:translate('settings.wearingPartCategories.deleteSuccess'), style: 'success' });
          })
      ), { dispatch: false }
    );

    // Wearing Part Category not deleted successfully
    deleteWearingPartCategoryFailure$ = createEffect(() =>
      this.actions$.pipe(
        ofType(WearingPartCategoryActions.deleteWearingPartCategoryFailure),
      ), { dispatch: false }
    );




    constructor(
        private actions$: Actions, 
        private wearingPartCategoryService: WearingPartCategoryService,
        private appnotificationService: AppNotificationService) {}
}